import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ButtonComponent from "@components/ButtonComponent";

const NO_INDEX = -1;
const UDID_MULTIPLIER = 100000;
const TERMINALID_MULTIPLIER = 1000;

const TerminalPopup = ({
  newData,
  handleInputChange,
  handleSave,
  setPopupOpen,
  isNew = false,
  hasHeader,
  type,
  dataId,
}) => {
  const { t: translate, i18n } = useTranslation();

  const [newDeviceName, setNewDeviceName] = useState("");

  const [newTerminalId] = useState(
    Math.floor(Math.random() * TERMINALID_MULTIPLIER)
  );
  const [newUdi] = useState(Math.floor(Math.random() * UDID_MULTIPLIER));

  return (
    <div data-testid="terminal-popup" className="">
      <h2 className="text-lg capitalize text-center dark:text-white font-bold mb-4">
        {isNew ? `Add new ${type} ` : `Edit ${type} `}
      </h2>
      {hasHeader && hasHeader()}
      <div className="mb-4">
        {isNew ? (
          <div className="mb-4 flex flex-col gap-2">
            <label className="block capitalize text-sm font-semibold dark:text-white">
              {translate("hierarchy.terminal-id")}
            </label>
            <input
              data-testid="terminal-add-input"
              type="text"
              value={newDeviceName}
              onChange={(e) => {
                const value = e.target.value;
                setNewDeviceName(value);

                const existingDeviceIndex = newData.OrgDevices?.findIndex(
                  (device) => device.DeviceId === newTerminalId
                );

                const newDevice = {
                  DeviceId: newTerminalId,
                  DeviceName: value,
                  StatusTag: "REGISTERED",
                  UDID: newUdi.toString(),
                  DeviceType: "POS",
                };

                const updatedDevices = [...(newData.OrgDevices || [])];

                if (existingDeviceIndex !== NO_INDEX) {
                  updatedDevices[existingDeviceIndex] = newDevice;
                } else {
                  updatedDevices.push(newDevice);
                }

                handleInputChange("OrgDevices", updatedDevices);
              }}
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white dark:border-gray-600"
            />
          </div>
        ) : (
          newData?.OrgDevices?.map((detail, index) => {
            if (detail.DeviceId !== dataId) return null;
            return (
              <div key={index} className="mb-4 flex flex-col gap-2 ">
                <label className="block capitalize text-sm dark:text-white font-semibold">
                  {translate("hierarchy.terminal-id")}
                </label>
                <input
                  data-testid={`terminal-edit-input`}
                  type="text"
                  value={detail.DeviceName || ""}
                  onChange={(e) => {
                    const updatedDevices = newData.OrgDevices.map((device) =>
                      device.DeviceId === dataId
                        ? { ...device, DeviceName: e.target.value }
                        : device
                    );
                    handleInputChange("OrgDevices", updatedDevices);
                  }}
                  className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
                />
              </div>
            );
          })
        )}
      </div>
      <div className="flex justify-between gap-2">
        <ButtonComponent
          color="red"
          type="cancel"
          onClick={() => setPopupOpen(false)}
          text={"Cancel"}
          className="mt-5 w-full"
        />
        <ButtonComponent
          data-testid="save-button"
          color="green"
          onClick={handleSave}
          text={isNew ? "Add Terminal" : "Save"}
          className="mt-5 w-full"
        />
      </div>
    </div>
  );
};

export default TerminalPopup;
